import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-14ab4721")

_pushScopeId("data-v-14ab4721")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "text-md-right" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "card"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-8" }
const _hoisted_10 = { class: "inline-items align-middle" }
const _hoisted_11 = { for: "" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_13 = {
  key: 1,
  ref: "table"
}
const _hoisted_14 = { class: "text-right p-3" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check" }, null, -1)
const _hoisted_16 = {
  style: {"overflow-x":"scroll"},
  class: "custom-table-responsive my-2 font-12 border with-line-item"
}
const _hoisted_17 = { class: "table table-bordered mb-0" }
const _hoisted_18 = { class: "table-primary nowrap-text" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "mr-3" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "dropdown-menu custom-scroll table-dropdown" }
const _hoisted_25 = { class: "dropdown-actions" }
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_28 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_29 = {
  class: "control-wrap",
  style: { width: '100%' }
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "control-wrap" }
const _hoisted_32 = { class: "dropdown-wrap position-relative" }
const _hoisted_33 = {
  class: "dropdown-toggle btn-sm bg-light h-100 rounded-0",
  type: "button",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_34 = { class: "mr-3" }
const _hoisted_35 = { class: "dropdown-menu with-badge-list" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "" }
const _hoisted_39 = { class: "text-nowrap" }
const _hoisted_40 = /*#__PURE__*/_createVNode("i", { class: "fa fa-copy" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_42 = { class: "shadow-none" }
const _hoisted_43 = {
  colspan: 8,
  class: "text-right"
}
const _hoisted_44 = { colspan: 3 }
const _hoisted_45 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus mr-1" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Add more item")
const _hoisted_47 = { class: "form-group text-right" }
const _hoisted_48 = {
  key: 0,
  class: "error-field-text"
}
const _hoisted_49 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_50 = { class: "modal-content" }
const _hoisted_51 = { class: "modal-header" }
const _hoisted_52 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_53 = { class: "modal-body" }
const _hoisted_54 = { class: "form-group with-mic-btns" }
const _hoisted_55 = { for: "" }
const _hoisted_56 = { class: "absolute-mic-wrap" }
const _hoisted_57 = { class: "modal-footer" }
const _hoisted_58 = {
  type: "button",
  class: "btn default-btn",
  "data-dismiss": "modal"
}
const _hoisted_59 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}
const _hoisted_60 = { class: "modal-wrap default-modal" }
const _hoisted_61 = {
  class: "modal fade",
  id: "addUnite",
  tabindex: -1,
  "aria-labelledby": "hidePojectLabel",
  "aria-hidden": "true"
}
const _hoisted_62 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_63 = { class: "modal-content" }
const _hoisted_64 = { class: "modal-header" }
const _hoisted_65 = {
  key: 0,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_66 = {
  key: 1,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_67 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_68 = { class: "modal-body" }
const _hoisted_69 = { class: "form-group" }
const _hoisted_70 = { for: "" }
const _hoisted_71 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_72 = { class: "form-group" }
const _hoisted_73 = { for: "" }
const _hoisted_74 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_75 = { class: "modal-footer" }
const _hoisted_76 = {
  key: 3,
  class: "modal-wrap default-modal"
}
const _hoisted_77 = { class: "custom-modal-overlay" }
const _hoisted_78 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_79 = { class: "modal-content" }
const _hoisted_80 = { class: "modal-header" }
const _hoisted_81 = {
  class: "modal-title",
  id: "view-modalLabel"
}
const _hoisted_82 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_83 = { class: "modal-body" }
const _hoisted_84 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_85 = { class: "text-danger" }
const _hoisted_86 = { class: "modal-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CustomLoader = _resolveComponent("CustomLoader")
  const _component_CustomModal = _resolveComponent("CustomModal")
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_VoiceToText = _resolveComponent("VoiceToText")
  const _component_CreateLineItemInJobEstimation = _resolveComponent("CreateLineItemInJobEstimation")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            (!_ctx.state.ui.isLoading.addNewSubItem)
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  href: "javascript:void(0)",
                  class: "btn default-btn d-inline-block mr-2",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNewSubItem && _ctx.addNewSubItem(...args)))
                }, _toDisplayString(_ctx.$t('create_line_item')), 1))
              : _createCommentVNode("", true),
            (_ctx.state.ui.isLoading.addNewSubItem)
              ? (_openBlock(), _createBlock("a", {
                  key: 1,
                  href: "javascript:void(0)",
                  class: "btn default-btn outline d-inline-block",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNewSubItem && _ctx.addNewSubItem(...args)))
                }, [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                ]))
              : (_openBlock(), _createBlock("a", {
                  key: 2,
                  href: "javascript:void(0)",
                  class: "btn default-btn outline d-inline-block",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('back-to-job-estimation-list')))
                }, [
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                ]))
          ])
        ])
      ])
    ]),
    (!_ctx.state.ui.isLoading.addNewSubItem)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("ul", null, [
                  _createVNode("li", null, [
                    _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('title')) + " :", 1)
                  ]),
                  _createVNode("li", null, [
                    _withDirectives(_createVNode("textarea", {
                      id: "title",
                      class: _ctx.state.ui.errors.titleError ? 'form-control error-field' : 'form-control',
                      name: "title",
                      rows: 2,
                      cols: 50,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.title = $event))
                    }, null, 2), [
                      [_vModelText, _ctx.state.data.title]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode(_component_CustomModal, {
            visible: _ctx.showItemModal,
            "onUpdate:visible": _cache[7] || (_cache[7] = val => { _ctx.showItemModal = val; _ctx.itemSearchedvalue = ''; })
          }, {
            default: _withId(() => [
              _createVNode("a", {
                class: "dropdown-item border-bottom text-success",
                href: "javascript:void(0)",
                onClick: _cache[5] || (_cache[5] = ()=>{
                        _ctx.addNewSubItem(_ctx.currenylySelectedState.index)
                        _ctx.showItemModal =false
                        
                    })
              }, "+ " + _toDisplayString(_ctx.$t('add_new_item')), 1),
              (_ctx.state.ui.isLoading.getData)
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode(_component_CustomLoader)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.currenylySelectedState?.value?.tableSelected)
                ? (_openBlock(), _createBlock("div", _hoisted_13, null, 512))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_14, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn btn-sm jobitem-btn",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeSelected(_ctx.currenylySelectedState.index)))
                }, [
                  _hoisted_15,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('ok')), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode("div", _hoisted_16, [
            _createVNode("table", _hoisted_17, [
              _createVNode("thead", _hoisted_18, [
                _createVNode("tr", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
                    return (_openBlock(), _createBlock("th", {
                      key: index,
                      style: { width: _ctx.columnWidths[index] + 'px' },
                      class: "resizable-column"
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t(column.label)) + " ", 1),
                      _createVNode("div", {
                        class: "resizer",
                        onMousedown: ($event: any) => (_ctx.startResize(index, $event)),
                        onTouchstart: ($event: any) => (_ctx.startResize(index, $event))
                      }, null, 40, ["onMousedown", "onTouchstart"])
                    ], 4))
                  }), 128))
                ])
              ]),
              (!_ctx.state.cloningSelectedItem)
                ? (_openBlock(), _createBlock("tbody", _hoisted_19, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectItems, (selectedItem, selectedItemIndex) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: selectedItem.id
                      }, [
                        _createVNode("td", {
                          title: selectedItem.name ? selectedItem.mainName + ':' + selectedItem.name : 'ChooseItem'
                        }, [
                          _createVNode("div", {
                            style: { width: _ctx.computedColumnWidth(0) }
                          }, [
                            _createVNode("a", {
                              class: [
                                            'border',
                                            'rounded',
                                            'py-2',
                                            'px-3',
                                            { 'border-danger': selectedItem.nameError, 'd-block': selectedItem.isEditing, 'd-none': !selectedItem.isEditing }
                                        ],
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-expanded": "false",
                              onClick: ()=>{
                                            _ctx.currenylySelectedState = {
                                                index: selectedItemIndex,
                                                value: selectedItem
                                            }
                                            _ctx.onToggleChooseItem(selectedItemIndex)
                                        }
                            }, [
                              (selectedItem.parent_id)
                                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(selectedItem.name ? selectedItem.mainName + ':' + selectedItem.name :
                                            'ChooseItem'), 1)
                                  ], 64))
                                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(selectedItem.name ? selectedItem.name : _ctx.$t('choose_item')), 1)
                                  ], 64))
                            ], 10, ["onClick"]),
                            _withDirectives(_createVNode("span", null, _toDisplayString(selectedItem.name ? (selectedItem.mainName ? selectedItem.mainName + ':' +
                                        selectedItem.name : selectedItem.name) : '-'), 513), [
                              [_vShow, !selectedItem.isEditing]
                            ])
                          ], 4)
                        ], 8, ["title"]),
                        _createVNode("td", {
                          title: selectedItem.description,
                          style: { width: _ctx.computedColumnWidth(1) }
                        }, [
                          (selectedItem.isEditing)
                            ? _withDirectives((_openBlock(), _createBlock("textarea", {
                                key: 0,
                                class: "form-control",
                                "onUpdate:modelValue": ($event: any) => (selectedItem.description = $event),
                                rows: 2,
                                onClick: ($event: any) => (_ctx.showAddDetails(selectedItemIndex)),
                                disabled: selectedItem.id == 0,
                                style: { width: _ctx.computedColumnWidth(1) }
                              }, null, 12, ["onUpdate:modelValue", "onClick", "disabled"])), [
                                [_vModelText, selectedItem.description]
                              ])
                            : (_openBlock(), _createBlock("span", _hoisted_20, _toDisplayString(selectedItem?.description ?? '-'), 1))
                        ], 12, ["title"]),
                        _createVNode("td", {
                          title: selectedItem.quantity,
                          style: { width: _ctx.computedColumnWidth(2) }
                        }, [
                          (selectedItem.isEditing)
                            ? _withDirectives((_openBlock(), _createBlock("input", {
                                key: 0,
                                type: "number",
                                class: selectedItem.quantityError ? 'form-control error-field' : 'form-control fw-control',
                                "onUpdate:modelValue": ($event: any) => (selectedItem.quantity = $event),
                                onKeyup: ($event: any) => (_ctx.calculateTotal(selectedItem)),
                                style: { width: _ctx.computedColumnWidth(2) }
                              }, null, 46, ["onUpdate:modelValue", "onKeyup"])), [
                                [_vModelText, selectedItem.quantity]
                              ])
                            : (_openBlock(), _createBlock("span", _hoisted_21, _toDisplayString(selectedItem?.quantity ?? '-'), 1))
                        ], 12, ["title"]),
                        _createVNode("td", null, [
                          _createVNode("div", {
                            class: "dropdown-wrap unit-dropdown position-relative",
                            style: { width: _ctx.computedColumnWidth(3) }
                          }, [
                            (selectedItem.isEditing)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  class: selectedItem.unitError ? 'dropdown-toggle d-block border rounded py-2 px-3 error-field' : 'dropdown-toggle d-block border rounded py-2 px-3',
                                  type: "button",
                                  "data-toggle": "dropdown",
                                  "aria-expanded": "false"
                                }, [
                                  _createVNode("span", _hoisted_22, _toDisplayString(selectedItem.unit ?
                                            selectedItem.unit.name : _ctx.$t('select_unit')), 1)
                                ], 2))
                              : (_openBlock(), _createBlock("span", _hoisted_23, _toDisplayString(selectedItem?.unit?.name ?? '-'), 1)),
                            _createVNode("div", _hoisted_24, [
                              _createVNode("a", {
                                class: "dropdown-item border-bottom text-success",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.addNewUnit(selectedItem))
                              }, "+ " + _toDisplayString(_ctx.$t('add_new_unit')), 9, ["onClick"]),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.unitLists, (unit, unitIndex) => {
                                return (_openBlock(), _createBlock("a", {
                                  class: "dropdown-item with-actions",
                                  href: "javascript:void(0)",
                                  key: unitIndex
                                }, [
                                  _createVNode("span", {
                                    class: "unit-title d-block",
                                    onClick: ($event: any) => (_ctx.changeUnit(selectedItemIndex, unit))
                                  }, _toDisplayString(unit.name), 9, ["onClick"]),
                                  _createVNode("span", _hoisted_25, [
                                    _createVNode("span", {
                                      class: "actions-text",
                                      onClick: ($event: any) => (_ctx.editUnit(unit))
                                    }, [
                                      _hoisted_26
                                    ], 8, ["onClick"]),
                                    _createVNode("span", {
                                      class: "actions-text ml-2",
                                      onClick: ($event: any) => (_ctx.deleteUnit(selectedItem, unit))
                                    }, [
                                      _hoisted_27
                                    ], 8, ["onClick"])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ], 4)
                        ]),
                        _createVNode("td", {
                          title: '$' + selectedItem.cost,
                          style: { width: _ctx.computedColumnWidth(4) }
                        }, [
                          (selectedItem.isEditing)
                            ? (_openBlock(), _createBlock("div", _hoisted_28, [
                                _createVNode("div", _hoisted_29, [
                                  _createVNode(_component_CurrencyInput, {
                                    class: selectedItem.costError ? 'hasError' : '',
                                    style: { width: _ctx.computedColumnWidth(4) },
                                    modelValue: selectedItem.cost,
                                    "onUpdate:modelValue": ($event: any) => (selectedItem.cost = $event),
                                    onChange: ($event: any) => (_ctx.calculateTotal(selectedItem))
                                  }, null, 8, ["class", "style", "modelValue", "onUpdate:modelValue", "onChange"])
                                ])
                              ]))
                            : (_openBlock(), _createBlock("span", _hoisted_30, _toDisplayString(selectedItem.cost), 1))
                        ], 12, ["title"]),
                        _createVNode("td", {
                          class: "text-nowrap",
                          style: { width: _ctx.computedColumnWidth(5) }
                        }, [
                          _createVNode("div", {
                            style: { width: _ctx.computedColumnWidth(5) },
                            class: "item-desc",
                            title: selectedItem.subTotal ? '$' + selectedItem.subTotal : ''
                          }, _toDisplayString(_ctx.usdPriceFormate(selectedItem.subTotal ? selectedItem.subTotal : 0)), 13, ["title"])
                        ], 4),
                        _createVNode("td", null, [
                          (selectedItem.isEditing)
                            ? (_openBlock(), _createBlock("div", {
                                key: 0,
                                class: "d-flex",
                                style: { width: _ctx.computedColumnWidth(6) }
                              }, [
                                _createVNode("div", _hoisted_31, [
                                  _createVNode(_component_CurrencyInput, {
                                    modelValue: selectedItem.markup,
                                    "onUpdate:modelValue": ($event: any) => (selectedItem.markup = $event),
                                    type: selectedItem.markup_type === 0 ? 'currency': 'percentage',
                                    onChange: ($event: any) => (_ctx.calculateTotal(selectedItem))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "onChange"])
                                ]),
                                _createVNode("div", _hoisted_32, [
                                  _createVNode("a", _hoisted_33, [
                                    _createVNode("span", _hoisted_34, _toDisplayString(selectedItem.markup_type == 0 ?
                                                '$' : '%'), 1)
                                  ]),
                                  _createVNode("div", _hoisted_35, [
                                    _createVNode("ul", null, [
                                      _createVNode("li", null, [
                                        _createVNode("a", {
                                          class: "dropdown-item",
                                          href: "javascript:void(0)",
                                          onClick: ($event: any) => (_ctx.changeMarkupType(selectedItemIndex, 0))
                                        }, "$ ", 8, ["onClick"]),
                                        (_ctx.defMarkUpType != 0)
                                          ? (_openBlock(), _createBlock("span", {
                                              key: 0,
                                              class: "badge badge-success",
                                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateMarkupType(0)))
                                            }, _toDisplayString(_ctx.$t('set_as_default')), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createVNode("li", null, [
                                        _createVNode("a", {
                                          class: "dropdown-item",
                                          href: "javascript:void(0)",
                                          onClick: ($event: any) => (_ctx.changeMarkupType(selectedItemIndex, 1))
                                        }, "%", 8, ["onClick"]),
                                        (_ctx.defMarkUpType != 1)
                                          ? (_openBlock(), _createBlock("span", {
                                              key: 0,
                                              class: "badge badge-success",
                                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateMarkupType(1)))
                                            }, _toDisplayString(_ctx.$t('set_as_default')), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ])
                              ], 4))
                            : (_openBlock(), _createBlock("span", _hoisted_36, _toDisplayString(selectedItem.markup), 1))
                        ]),
                        _createVNode("td", {
                          style: { width: _ctx.computedColumnWidth(7) }
                        }, [
                          _createVNode("input", {
                            disabled: !selectedItem.isEditing,
                            style: { width: _ctx.computedColumnWidth(7) },
                            type: "checkbox",
                            checked: selectedItem.isAllowance,
                            onChange: ($event: any) => (_ctx.handleCheckboxChange(selectedItem, selectedItemIndex, $event))
                          }, null, 44, ["disabled", "checked", "onChange"])
                        ], 4),
                        _createVNode("td", {
                          style: { width: _ctx.computedColumnWidth(8) }
                        }, [
                          (selectedItem.isEditing)
                            ? (_openBlock(), _createBlock(_component_CurrencyInput, {
                                key: 0,
                                disabled: !selectedItem.isAllowance,
                                style: { width: _ctx.computedColumnWidth(8) },
                                modelValue: selectedItem.allowance,
                                "onUpdate:modelValue": ($event: any) => (selectedItem.allowance = $event)
                              }, null, 8, ["disabled", "style", "modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createBlock("span", _hoisted_37, _toDisplayString(selectedItem?.allowance ?? 0), 1))
                        ], 4),
                        _createVNode("td", {
                          class: "text-nowrap",
                          title: '$' + selectedItem.total,
                          style: { width: _ctx.computedColumnWidth(9) }
                        }, [
                          _createVNode("div", _hoisted_38, [
                            _createVNode("div", {
                              style: { width: _ctx.computedColumnWidth(9) },
                              class: "item-desc"
                            }, _toDisplayString(_ctx.usdPriceFormate(selectedItem.total ? selectedItem.total : 0)), 5)
                          ])
                        ], 12, ["title"]),
                        _createVNode("td", _hoisted_39, [
                          _createVNode("div", {
                            style: { width: _ctx.computedColumnWidth(10) }
                          }, [
                            (selectedItem.id)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  href: "javascript:void(0)",
                                  class: "btn btn-info mr-2",
                                  onClick: ($event: any) => (_ctx.cloneItem(selectedItemIndex, selectedItem)),
                                  title: _ctx.$t('copy')
                                }, [
                                  _hoisted_40
                                ], 8, ["onClick", "title"]))
                              : _createCommentVNode("", true),
                            (selectedItem.id)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 1,
                                  href: "javascript:void(0)",
                                  class: "btn delete-btn",
                                  onClick: ($event: any) => (_ctx.deleteItemShow(selectedItem)),
                                  title: _ctx.$t('remove')
                                }, [
                                  _hoisted_41
                                ], 8, ["onClick", "title"]))
                              : _createCommentVNode("", true)
                          ], 4)
                        ])
                      ]))
                    }), 128)),
                    _createVNode("tr", _hoisted_42, [
                      _createVNode("td", _hoisted_43, [
                        _createVNode("p", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('markup')), 1)
                        ]),
                        _createVNode("p", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('total')), 1)
                        ])
                      ]),
                      _createVNode("td", _hoisted_44, [
                        _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(_ctx.totalMarkUP)), 1),
                        _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(_ctx.total)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectItems, (selectedItem, selectedItemIndex) => {
            return (_openBlock(), _createBlock("div", { key: selectedItemIndex }, [
              (selectedItemIndex == _ctx.state.selectItems.length - 1)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    class: "btn enable-btn mr-1 btn-sm my-2 d-inline-flex align-items-center",
                    onClick: ($event: any) => (_ctx.addMoreSubItems(selectedItem)),
                    title: _ctx.$t('add')
                  }, [
                    _hoisted_45,
                    _hoisted_46
                  ], 8, ["onClick", "title"]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createVNode("div", _hoisted_47, [
            (_ctx.state.ui.errors.hasError)
              ? (_openBlock(), _createBlock("p", _hoisted_48, _toDisplayString(_ctx.$t('input_field_required')) + ".", 1))
              : _createCommentVNode("", true),
            (_ctx.state.ui.isLoading.isEdit)
              ? (_openBlock(), _createBlock("button", {
                  key: 1,
                  type: "submit",
                  class: "btn default-btn mr-2",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.updateJobEstimation && _ctx.updateJobEstimation(...args))),
                  disabled: _ctx.state.ui.isPostLoading.createJobEstimation
                }, _toDisplayString(_ctx.$t('save')), 9, ["disabled"]))
              : (_openBlock(), _createBlock("button", {
                  key: 2,
                  type: "submit",
                  class: "btn default-btn mr-2",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.creatJobEstimation && _ctx.creatJobEstimation(...args))),
                  disabled: _ctx.state.ui.isPostLoading.createJobEstimation
                }, _toDisplayString(_ctx.state.ui.isPostLoading.createJobEstimation ?
                    _ctx.$t('loading1') : _ctx.$t('save')), 9, ["disabled"])),
            (_ctx.state.ui.isLoading.isEdit)
              ? (_openBlock(), _createBlock("button", {
                  key: 3,
                  type: "submit",
                  class: "btn default-btn mr-2",
                  disabled: _ctx.state.ui.isPostLoading.createJobEstimation,
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.saveSend && _ctx.saveSend(...args)))
                }, _toDisplayString(_ctx.$t('save_and_send')), 9, ["disabled"]))
              : (_openBlock(), _createBlock("button", {
                  key: 4,
                  type: "submit",
                  class: "btn default-btn mr-2",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.saveSend && _ctx.saveSend(...args))),
                  disabled: _ctx.state.ui.isPostLoading.createJobEstimation
                }, _toDisplayString(_ctx.$t('save_and_send')), 9, ["disabled"])),
            _createVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.clearAllJobItem && _ctx.clearAllJobItem(...args)))
            }, _toDisplayString(_ctx.$t('clear')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 1,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectItems, (selectedItem, selectedItemIndex) => {
      return (_openBlock(), _createBlock("div", {
        class: "modal-wrap default-modal",
        key: 'modal-' + selectedItemIndex
      }, [
        _createVNode("div", {
          class: "modal fade",
          id: 'addDetails' + selectedItemIndex,
          tabindex: -1,
          "aria-labelledby": "addDetails",
          "aria-hidden": "true"
        }, [
          _createVNode("div", _hoisted_49, [
            _createVNode("div", _hoisted_50, [
              _createVNode("div", _hoisted_51, [
                _createVNode("h5", {
                  class: "modal-title",
                  id: 'addDetails' + selectedItemIndex
                }, _toDisplayString(_ctx.$t('add_details')), 9, ["id"]),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_52
                ])
              ]),
              _createVNode("div", _hoisted_53, [
                _createVNode("div", _hoisted_54, [
                  _createVNode("label", _hoisted_55, _toDisplayString(_ctx.$t('description')), 1),
                  _withDirectives(_createVNode("textarea", {
                    class: "form-control",
                    "onUpdate:modelValue": ($event: any) => (selectedItem.description = $event),
                    rows: 20,
                    cols: 60
                  }, null, 8, ["onUpdate:modelValue"]), [
                    [_vModelText, selectedItem.description]
                  ]),
                  _createVNode("div", _hoisted_56, [
                    _createVNode(_component_VoiceToText, {
                      onStartRecording: ($event: any) => (_ctx.startRecording(selectedItemIndex, $event))
                    }, null, 8, ["onStartRecording"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_57, [
                _createVNode("button", _hoisted_58, _toDisplayString(_ctx.$t('save')), 1),
                _createVNode("button", _hoisted_59, _toDisplayString(_ctx.$t('cancel')), 1)
              ])
            ])
          ])
        ], 8, ["id"])
      ]))
    }), 128)),
    _createVNode("div", _hoisted_60, [
      _createVNode("div", _hoisted_61, [
        _createVNode("div", _hoisted_62, [
          _createVNode("div", _hoisted_63, [
            _createVNode("div", _hoisted_64, [
              (_ctx.state.ui.isLoading.isUnitEdit)
                ? (_openBlock(), _createBlock("h5", _hoisted_65, _toDisplayString(_ctx.$t('update')) + " " + _toDisplayString(_ctx.$t('unit')), 1))
                : (_openBlock(), _createBlock("h5", _hoisted_66, _toDisplayString(_ctx.$t('add_unit')), 1)),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_67
              ])
            ]),
            _createVNode("div", _hoisted_68, [
              _createVNode("div", _hoisted_69, [
                _createVNode("label", _hoisted_70, _toDisplayString(_ctx.$t('name')), 1),
                _withDirectives(_createVNode("input", {
                  class: _ctx.state.ui.errors.validationErrorList.unitName ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.data.unit.name = $event))
                }, null, 2), [
                  [_vModelText, _ctx.state.data.unit.name]
                ]),
                (_ctx.state.ui.errors.validationErrorList.unitName)
                  ? (_openBlock(), _createBlock("p", _hoisted_71, _toDisplayString(_ctx.state.ui.errors.validationErrorList.unitName), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_72, [
                _createVNode("label", _hoisted_73, _toDisplayString(_ctx.$t('abbreviation')), 1),
                _withDirectives(_createVNode("input", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.state.data.unit.abbreviation = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.unit.abbreviation]
                ]),
                (_ctx.state.ui.errors.validationErrorList.unitAbbreviation)
                  ? (_openBlock(), _createBlock("p", _hoisted_74, _toDisplayString(_ctx.state.ui.errors.validationErrorList.unitAbbreviation), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_75, [
              (_ctx.state.ui.isLoading.isUnitEdit)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.updateUnit && _ctx.updateUnit(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.addUnite ? _ctx.$t('loading1') : _ctx.$t('update')), 1))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.createUnit && _ctx.createUnit(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.addUnite ? _ctx.$t('loading1') : _ctx.$t('save')), 1)),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args)))
              }, _toDisplayString(_ctx.$t('cancel')), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.ui.isLoading.addNewSubItem)
      ? (_openBlock(), _createBlock(_component_CreateLineItemInJobEstimation, {
          key: 2,
          onSave: _ctx.saveItem,
          dataFor: _ctx.state.dataFor,
          itemId: _ctx.state.selectItemId
        }, null, 8, ["onSave", "dataFor", "itemId"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showDeleteItem)
      ? (_openBlock(), _createBlock("div", _hoisted_76, [
          _createVNode("div", _hoisted_77, [
            _createVNode("div", _hoisted_78, [
              _createVNode("div", _hoisted_79, [
                _createVNode("div", _hoisted_80, [
                  _createVNode("h5", _hoisted_81, _toDisplayString(_ctx.$t('delete_subitem')), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "modal",
                    "aria-label": "Close",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.deleteItemClose()))
                  }, [
                    _hoisted_82
                  ])
                ]),
                _createVNode("div", _hoisted_83, [
                  _hoisted_84,
                  _createVNode("span", _hoisted_85, _toDisplayString(_ctx.$t('are_you_sure')), 1)
                ]),
                _createVNode("div", _hoisted_86, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.deleteItemClose()))
                  }, _toDisplayString(_ctx.$t('no')), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-danger",
                    "data-dismiss": "modal",
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.removeSelectedSubItem(_ctx.state.selectDeleteItem)))
                  }, _toDisplayString(_ctx.$t('yes')), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})